// Fixed and improved API interactions
import axios from "axios";
import { toast } from "react-toastify"; // Assuming toast notifications are handled by react-toastify
const API_URL = import.meta.env.VITE_API_URL_AUTH;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 403 ||
      error.response?.status === 401
    ) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const handleError = (error) => {
  if (error.response) {
    const { status, data } = error.response;
    if (data && data.message) {
      toast.error(data.message);
    }
    switch (status) {
      case 500:
        throw new Error("Server Error (500): Please try again later.");
      case 422:
        throw new Error("Validation Error (422): Check your input.");
      case 401:
        localStorage.clear();
        window.location.href = "/login";
        throw new Error("Unauthorized (401): Please log in.");
      default:
        throw new Error(`Unexpected API Error: ${status}`);
    }
  } else {
    throw new Error("Network Error or Server Unreachable.");
  }
};

export const getRoleList = async (params) => {
  try {
    const response = await axiosInstance.get(`/role/v1`, { params }); // Use Axios instance to make the GET request
    return response?.data?.data;
  } catch (error) {
    handleError(error);
  }
};

export const addRole = async (data) => {
  try {
    const response = await axiosInstance.post("/role/v1", data);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateRole = async (data) => {
  try {
    const response = await axiosInstance.put("/role/v1", data);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteRole = async (data) => {
  try {
    const response = await axiosInstance.delete("/role/v1", { data });
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getUserList = async (params) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await axiosInstance.get("/user/v1", { params });
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const addUser = async (data) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await axiosInstance.post("/user/v1", data);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateUser = async (data) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await axiosInstance.put("/user/v1", data);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteUser = async (data) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await axiosInstance.delete("/user/v1", {
      data: data,
    });
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateUserImage = async (data) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await axiosInstance.put("/user-image/v1", data);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const sentPasswordResetLink = async (data) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await axios.post(`${API_URL}/send-email/v1`, data);
    return response?.data;
  } catch (error) {
    toast.error(error?.response?.data?.message);
    // handleError(error);
  }
};
